import { Component, OnDestroy, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActivatedRoute } from '@angular/router';
import { Subject, lastValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';
import { BreadcrumbService } from '@suvo/frontend/standalone/breadcrumb';
import { ExportService } from '../../export.service';

@Component({
  selector: 'app-export-view-screen',
  templateUrl: './export-view-screen.component.html',
})
export class ExportViewScreenComponent implements OnInit, OnDestroy {
  private readonly unsubscribe$ = new Subject<void>();

  export;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly auth: AngularFireAuth,
    private readonly breadcrumb: BreadcrumbService,
    private exportService: ExportService,
  ) {}

  async ngOnInit() {
    let params = await lastValueFrom(this.activatedRoute.params.pipe(take(1)));

    this.breadcrumb.setDynamicNameSwap('export', params.id);

    this.export = await this.exportService.getById(params.id);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
